import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TestimonialsComponent } from "../testimonials/testimonials.component";
import { PlansComponent } from '../plans/plans.component';
import { EnrollNowComponent } from "../enroll-now/enroll-now.component";
import { BuyBookComponent } from '../../../../buy-book/buy-book.component';


@Component({
  selector: 'app-default',
  standalone: true,
  imports: [RouterModule, TestimonialsComponent, PlansComponent, EnrollNowComponent, BuyBookComponent],
  templateUrl: './default.component.html',
  styleUrl: './default.component.css'
})
export class DefaultComponent {

  constructor(
    private _router: Router
  ) { }

  // ngAfterViewInit(): void {
  //   if (typeof document !== 'undefined') {
  //     const script = document.createElement('script');
  //     script.src = 'assets/js/all-instructor-custom.js'; // path to your JS
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }
  // }

  ngAfterViewInit(): void {
    // Only run in the browser
    if (typeof document === 'undefined') return;

    const script = Object.assign(document.createElement('script'), {
      src: 'assets/js/all-instructor-custom.js',
      async: true
    });

    document.body.appendChild(script);
  }

}
